import { Card } from 'primereact/card'
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Panel } from 'primereact/panel';
import { RadioButton } from 'primereact/radiobutton'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { getCountry, fetchlanguage } from '../reduxactions/doctoractions/DoctorProfileActions';
import { getSpeciality } from '../reduxactions/suprivisoractions/SupDoctorsActions';
import { fetchAppointmentsData, fetchCloseCases, fetchOpenCases } from '../reduxactions/patientactions/PatientCasesActions';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
// import './NewCase.css'
import { fetchApplication, fetchHospitalData } from '../reduxactions/patientactions/NewCaseActions';
import { Admin_API, PATIENT_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Button } from 'primereact/button';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const MobNewCase = () => {
  // const uid = window.sessionStorage.getItem('uid');
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid') as string;
  // const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');
  const [casetype, setCaseType] = useState('CORONA');
  const [language, setLanguage] = useState('');
  const [country, setCountry] = useState('');
  const [sickdesc, setSickDesc] = useState('');
  const [SpecilityName, setSpeciality] = useState('');
  const [hospital, setHospital] = useState('');
  const [sickness, setSickness] = useState('');
  const [application, setApplication] = useState('');
  const [DoctorID, setDoctorID] = useState<any>('');

  const countrydata = useSelector((state: RootState) => state.doctorprofile.country);
  const dispatch = useDispatch();

  useEffectOnce(() => {
    const fetchcountry = async () => {
      try {
        await dispatch(getCountry() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchcountry();
  }, [dispatch]);

  const lang = useSelector((state: RootState) => state.doctorprofile.lan);
  useEffectOnce(() => {
    const fetchLangData = async () => {
      try {
        await dispatch(fetchlanguage() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchLangData();
  }, [dispatch]);
  const specialitysss = useSelector((state: RootState) => state.sdoctorss.special);

  useEffectOnce(() => {
    const FetchSpeciality = async () => {
      try {
        await dispatch(getSpeciality(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    FetchSpeciality();
  }, [dispatch]);
  const hospdata = useSelector((state: RootState) => state.newcase.hospital);
  useEffectOnce(() => {
    const FetchHoso = async () => {
      try {
        await dispatch(fetchHospitalData() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    FetchHoso();
  }, [dispatch]);


  const [userData, setUserData] = useState<[]>([]);

  const fetchSickness = async (SpecilityID: any) => {
    try {
      const payload = { specility: SpecilityID };
      const apiname = PATIENT_API.sickness_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // const applicationdata = useSelector((state: RootState) => state.newcase.application);
  const [applicationdata, setApplicationData] = useState<[]>([]);
  const [appid, setApiId] = useState('');
  const fetchApp = async () => {
    try {
      const payload = { uid: uid };
      const apiname = PATIENT_API.aaapplication_API;
      const response = await LoginService.getData(apiname, payload);
      setApplicationData(response);
      const appid = response[0]?.appid;
      setApiId(appid);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchApp();
  }, [dispatch]);
  const [appData, setAppData] = useState<[]>([]);
  const [applicationDetailsData, setApplicationDetailsData] = useState(false);
  // console.log("data",appData)
  const getAPPData = async (appid: any) => {
    try {
      const payload = { appid: appid };
      const apiname = PATIENT_API.application_details_API;
      const response = await LoginService.getData(apiname, payload);
      setAppData(response);
      setApplicationDetailsData(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const submitApplicationData = async () => {
    try {
      const payload = { uid: uid, appid: appid };
      const apiname = PATIENT_API.createapplication_API;
      const response = await LoginService.getData(apiname, payload);
      const url = '/patientcases';
      navigate(url);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //submit 
  const navigate = useNavigate();
  const CreateCase = async () => {
    try {
      const payload = { country: country, language: language, sicknessdesc: sickdesc, uid: uid };
      const apiname = PATIENT_API.casecreation_API;
      const response = await LoginService.getData(apiname, payload);
      navigate(`/mobcaseslist/${uid}`);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const addCase = () => {
    if (SpecilityName && sickdesc && sickness) {
      const queryParams = {
        specialityid: SpecilityName,
        sicknessdesc: sickdesc,
        sicknessid: sickness,
        uid: uid,
      };
      const queryString = new URLSearchParams(queryParams).toString();
      navigate(`/moburgentcasecreation?${queryString}`);
    }
  }

  const [getDoctorData, setDoctorData] = useState<[]>([]);
  const toast = useRef<Toast>(null);
  // const assignData = useRef({ image: '' });
  // const viewPage = (rowData: any) => {
  //   assignData.current = { image: rowData.image };
  //   console.log(assignData.current,"id");
  //   setViewDilog(true);
  // };
  const SearchDoctor = async () => {
    try {
      const payload = { country: country, hospital: hospital, language: language, speciality: SpecilityName };
      const apiname = PATIENT_API.searchdoctor_API;
      const response = await LoginService.getData(apiname, payload);
      // if (response && response.length > 0) {
      setDoctorData(response);
      setDoctorID(response[0].DoctorID);
      // } else {
      //   if (toast.current) {
      //     toast.current.show({
      //       severity: 'error',
      //       summary: 'No Doctor Found',
      //       detail: 'Please try with different filters.',
      //       life: 3000
      //     });
      //   }
      getDoctorProfile(response[0].DoctorID);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const AddNormalCase = () => {
    if (getDoctorData !== null) {
      if (DoctorID && hospital && SpecilityName && country) {
        const queryParams = {
          doctorid: DoctorID,
          hospitalid: hospital,
          countryid: country,
          specialityid: SpecilityName,
          uid: uid
        };
        const queryString = new URLSearchParams(queryParams).toString();
        navigate(`/mobnormalcase?${queryString}`);
      }
    }
  }
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };
  //for doctor
  const [getDoctorProfileData, setGetDoctorProfileData] = useState<[]>([]);
  const [getDocDilog, setDocDilog] = useState(false);


  const hideDilog = () => {
    setDocDilog(false);
    setGetDoctorProfileData([]);
    console.log(getDoctorProfileData, "DoctorData")
  }
  const showDilog = (event: any) => {
    console.log(event, "event")
    setDocDilog(true);
    getDoctorProfile(event.DoctorID);

  }
  const getDoctorProfile = async (event: any) => {
    try {
      const payload = { doctorid: event, q: 3 };
      const apiname = Admin_API.Doc_API;
      const response = await LoginService.getData(apiname, payload);
      setGetDoctorProfileData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // useEffect(() => {
  //   getDoctorProfile()
  // }, [dispatch]);
  const [feedbackDilog, setFeedbackDilog] = useState(false);
  const [data, setData] = useState<[]>([]);
  const fetchDocDetails = async () => {
    try {
      const payload = { doctorid: DoctorID, q: 5 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setData(response);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [data1, setData1] = useState<[]>([]);
  const [avgtime, setAvgTime] = useState('');
  const fetchTimeDetails = async () => {
    try {
      const payload = { doctorid: DoctorID, q: 6 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setData1(response);
      setAvgTime(response[0].avgresponse)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDocDetails();
    fetchTimeDetails();
  }, [dispatch]);

  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/mobnewcase.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>New Case</h1>
                  </div>
                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section className="content">
              <div className="container-fluid">
                <div className="grid">
                  <div className="col-12">
                    <Card>
                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginRight: '10px' }}>Show:</label>
                        <div className="flex flex-wrap gap-3">
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="coronaCase"
                              name="caseType"
                              value="CORONA"
                              onChange={(e) => setCaseType(e.value)}
                              checked={casetype === 'CORONA'}
                            />
                            <label htmlFor="coronaCase" className="ml-2">CORONA Case</label>
                          </div>
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="normalCase"
                              name="caseType"
                              value="Normal"
                              onChange={(e) => setCaseType(e.value)}
                              checked={casetype === 'Normal'}
                            />
                            <label htmlFor="normalCase" className="ml-2">Normal Case</label>
                          </div>
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="urgentCase"
                              name="caseType"
                              value="Urgent"
                              onChange={(e) => setCaseType(e.value)}
                              checked={casetype === 'Urgent'}
                            />
                            <label htmlFor="urgentCase" className="ml-2">Urgent Case</label>
                          </div>
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="medicalCase"
                              name="caseType"
                              value="Medical"
                              onChange={(e) => setCaseType(e.value)}
                              checked={casetype === 'Medical'}
                            />
                            <label htmlFor="medicalCase" className="ml-2">Medical Insurance</label>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
                {casetype === 'CORONA' && (
                  <Panel header="CORONA Case" style={{ marginTop: '20px' }}>
                    <div className='grid'>
                      <div className="col-6">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="fname" className="block text-900 font-medium ">Language</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="country" value={language} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setLanguage(e.value)} options={lang} optionLabel="Lang" optionValue="LangID" placeholder="Select a Language" style={{ width: '400px' }} />
                        </div>
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="email" className="block text-900 font-medium ">Sickness Description</label>
                        </div>
                        <div className="col-3">
                          <InputTextarea id="phone" placeholder="Enter Sickness Description" value={sickdesc} onChange={(e) => setSickDesc(e.target.value)} style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="lname" className="block text-900 font-medium">Country</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="country" value={country} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setCountry(e.value)} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-12 card-footer">
                        <Button label="Submit" onClick={CreateCase} style={{ marginLeft: '35px' }} />

                      </div>
                    </div>
                  </Panel>
                )}

                {casetype === 'Normal' && (
                  <Panel header="Normal Case" style={{ marginTop: '20px' }}>
                    <div className='grid'>
                      <div className="col-6">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="fname" className="block text-900 font-medium ">Language</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="country" value={language} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setLanguage(e.value)} options={lang} optionLabel="Lang" optionValue="LangID" placeholder="Select a Language" style={{ width: '400px' }} />
                        </div>
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="lname" className="block text-900 font-medium">Country</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="country" value={country} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setCountry(e.value)} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="fname" className="block text-900 font-medium ">Specility</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="speciality" value={SpecilityName} onChange={(e: DropdownChangeEvent) => setSpeciality(e.value)} options={specialitysss} optionLabel="SpecilityName" optionValue="SpecilityID" placeholder="Select a Speciality" className="custom-dropdown-placeholder" style={{ width: '400px' }} />
                        </div>
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="lname" className="block text-900 font-medium">Hospital</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="speciality" value={hospital} onChange={(e: DropdownChangeEvent) => setHospital(e.value)} options={hospdata} optionLabel="hospitalname" optionValue="hospitalID" placeholder="Select a Hospital" className="custom-dropdown-placeholder" style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-10 card-footer">
                        <Button label="Search Doctor" onClick={SearchDoctor} style={{ marginLeft: '35px' }} />

                      </div>
                    </div>
                  </Panel>
                )}

                {casetype === 'Urgent' && (
                  <Panel header="Urgent Case" style={{ marginTop: '20px' }}>
                    <div className='grid'>
                      <div className="col-6">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="fname" className="block text-900 font-medium ">Speciality</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="speciality" value={SpecilityName} onChange={(e: DropdownChangeEvent) => { fetchSickness(e.value); setSpeciality(e.value) }} options={specialitysss} optionLabel="SpecilityName" optionValue="SpecilityID" placeholder="Select a Speciality" className="custom-dropdown-placeholder" style={{ width: '400px' }} />
                        </div>
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="email" className="block text-900 font-medium ">Sickness Description</label>
                        </div>
                        <div className="col-3">
                          <InputTextarea id="phone" placeholder="Enter Sickness Description" value={sickdesc} onChange={(e) => setSickDesc(e.target.value)} style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="lname" className="block text-900 font-medium">Sickness</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="country" value={sickness} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setSickness(e.value)} options={userData} optionLabel="Sickness" optionValue="SickID" placeholder="Select a Sickness" style={{ width: '400px' }} />
                        </div>
                      </div>
                      <div className="col-12 card-footer">
                        <Button label="Submit" style={{ marginLeft: '35px' }} onClick={addCase} />
                        {/*  */}
                      </div>
                    </div>
                  </Panel>
                )}

                {casetype === 'Medical' && (
                  <Panel header="Medicall Application" style={{ marginTop: '20px' }}>
                    <div className='grid'>
                      <div className="col-6" style={{ marginLeft: '400px' }}>
                        <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                          <label htmlFor="fname" className="block text-900 font-medium ">Application</label>
                        </div>
                        <div className="col-3">
                          <Dropdown id="speciality" value={application} onChange={(e: DropdownChangeEvent) => { getAPPData(e.value); setApplication(e.value) }} options={applicationdata} optionLabel="appid" optionValue="appid" placeholder="Select a Application" className="custom-dropdown-placeholder" style={{ width: '400px' }} />
                        </div>

                      </div>
                    </div>
                  </Panel>
                )}
                <Panel>
                  <div className='grid'>
                    {getDoctorData.map((response: any, index: any) => (
                      <Card header="" style={{ width: '320px', marginTop: '20px' }}>
                        <div
                          className="widget-user-header bg-info"
                          style={{
                            height: '120px',
                            backgroundColor: 'rgb(255, 193, 7)',
                            display: 'flex',
                            alignItems: 'center',
                            width: '115%',
                            marginLeft: '-21px',
                            marginTop: '-40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                          }}
                        >
                          <img
                            src={response.photo}
                            alt="User Avatar"
                            style={{
                              width: '110px',
                              height: '80px',
                              borderRadius: '50%',
                              padding: '3px',
                              backgroundColor: 'rgb(255, 193, 7)',
                              marginRight: '15px',
                              marginLeft: '20px',
                              border: '3px solid #adb5bd',
                            }}
                          />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h2
                              className="widget-user-username"
                              style={{
                                color: 'black',
                                fontWeight: '200',
                                fontSize: '25px',
                                marginBottom: '10px',
                              }}
                            >
                              {response.hospitalname}
                            </h2>
                            <h3
                              className="widget-user-username"
                              style={{
                                color: '#6c757d',
                                fontSize: '1rem',
                                margin: '0',
                                fontWeight: '400',
                              }}
                            >
                              Doctor
                            </h3>
                          </div>
                        </div>

                        {[
                          { label: 'Speciality', value: response.SpecilityName, bgColor: 'rgb(0, 123, 255)' },
                          { label: 'Country', value: response.CountryName, bgColor: 'rgb(23, 162, 184)' },
                        ].map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="grid"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '0px',
                              }}
                            >
                              <strong
                                style={{
                                  width: '100px',
                                  fontWeight: '500',
                                  textAlign: 'left', marginLeft: '20px',
                                  marginTop: '-5px',
                                }}
                              >
                                {item.label}
                              </strong>
                              <p
                                className="text-muted"
                                style={{
                                  backgroundColor: item.bgColor,
                                  color: 'white',
                                  borderRadius: '6px',
                                  textAlign: 'center',
                                  marginLeft: '15px',
                                  padding: '5px 10px',
                                  display: 'inline-block',
                                }}
                              >
                                {item.value}
                              </p>
                            </div>
                            {index < 3 && (
                              <hr
                                style={{
                                  width: '115%',
                                  border: '0.5px solid rgba(0, 0, 0, 0.1)',
                                  margin: '-8px 0',
                                  marginLeft: '-20px'
                                }}
                              />
                            )}
                          </React.Fragment>
                        ))}
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                          <a style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }} onClick={() => showDilog(response)}>Doctor's Profile</a>
                        </div>
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                          <a style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }} onClick={() => setFeedbackDilog(true)} >Patient's Feedback</a>
                        </div>
                        <Button label='Select' className='select-button' onClick={AddNormalCase} />

                      </Card>
                    ))}
                  </div>

                </Panel>
                {casetype === 'Medical' && (
                  <>
                    {appData.map((response: any) => (
                      <div className="grid">
                        <div className="col-8">

                          <section className="content" >
                            <Panel header="Application Details" style={{ width: '151%', padding: '0.6rem 0' }} toggleable >
                              <div className="grid" >

                                <div className="col-12 md:col-12 lg:col-5" style={{ marginLeft: '60px' }}>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Application ID :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.appid}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Application Type :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.apptype}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Patient Name :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.patient_name}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Date Of Birth:</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pdob}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Email  :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pemail}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Phone No :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pmob}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Identity Proof Type :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.id_proof}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Identit Proof Number :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.id_card_num}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>State :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pstate}</p>
                                  </div>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>State :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.country}</p>
                                  </div>
                                </div>

                                <div className="col-12 md:col-12 lg:col-5" style={{ marginLeft: '60px' }}>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Employee Name :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.emp_name}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Employee ID :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.emp_id}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Relation With Employee :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.relation}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Card Number :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.health_card}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Sickness :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.sickness}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Description :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.sick_desc}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Prefered Doctor :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pref_doctor}</p>
                                  </div>

                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Prefered Hospital :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hospitalname}</p>
                                  </div>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Prefered State :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pref_state}</p>
                                  </div>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Prefered Country :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.pref_country}</p>
                                  </div>
                                  <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ width: '200px', textAlign: 'start' }}>Status :</strong>
                                    <p className="text-muted" style={{ marginLeft: '10px' }}>{response.status}</p>
                                  </div>
                                </div>
                                <div style={{ display: 'block', alignItems: 'center' }}>
                                  <input
                                    type="checkbox"
                                    id="remember"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    style={{ marginRight: '10px' }}
                                  />
                                  <label htmlFor="terms" className="p-checkbox-label"><span style={{ color: 'rgb(102, 102, 102)', fontWeight: '900', fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol', fontSize: '18px' }}>Do you really want to add case to this doctor? then check this.</span></label>
                                </div>
                                <div>
                                  <Button
                                    label="Submit Query"
                                    style={{ backgroundColor: '#117a8b', marginTop: '40px', marginRight: '20px', border: 'none' }}
                                    onClick={submitApplicationData}
                                    disabled={!isChecked}
                                  />
                                </div>

                              </div>
                            </Panel>


                          </section>
                        </div>
                      </div>
                    ))}
                  </>
                )}

              </div >
            </section >
            {/* < Dialog style={{ width: '80vw' }} visible={getDocDilog} onHide={() => setDocDilog(false)}> */}
            < Dialog style={{ width: '80vw' }} visible={getDocDilog} onHide={hideDilog}>
              {getDoctorProfileData.map((response: any) => (
                <Panel header="Doctor Details" style={{ width: '100%' }} toggleable>
                  <div className="grid" >
                    <div className="col-12 md:col-12 lg:col-4" style={{ marginLeft: '100px' }}>
                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Doctor Name :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.firstName}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Email :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.email}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Address :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.address}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Phone :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.phone}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>City :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.city}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>State :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.statename}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Country :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.country}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Speciality :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.specialty}</p>
                      </div>
                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Category :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.plan}</p>
                      </div>
                    </div>

                    <div className="col-12 md:col-12 lg:col-5" style={{ marginLeft: '80px' }}>
                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Hospital Name :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hospitalname}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Hospital Prefix :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hospitalprefix}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Email :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hemail}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Phone No:</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hphone}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Address :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.address}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>City :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hcity}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>State :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hstate}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Country :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hcountry}</p>
                      </div>

                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '150px', textAlign: 'start' }}>Status :</strong>
                        <p className="text-muted" style={{ marginLeft: '10px' }}>{response.status}</p>
                      </div>
                    </div>



                  </div>
                </Panel>
              ))}
            </Dialog >
            < Dialog header="Feedback" style={{ width: '80vw' }} visible={feedbackDilog} onHide={() => setFeedbackDilog(false)}>
              <div className="row">
                <div className="col-md-12">

                  <h3 className='text-center'> Average Response Time : Hrs {avgtime} Min </h3>

                  <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                    <Column field="Category" header="Created Date"></Column>
                    <Column field="Amount" header="Overallsatiesfaction"></Column>
                    <Column field="Amount" header="Suggestion"></Column>

                  </DataTable>

                </div>

              </div>
            </Dialog>

          </div >
        </div>
        <Toast ref={toast} />
      </div>
    </div>
  )
}